/** @returns {Record<string, unknown> | null} */
export function jobClientRecord(job) {
  if (!job) return null;
  return job.client_record || job.clientRecord || null;
}

export function resolveJobPhone(job) {
  const cr = jobClientRecord(job);
  const raw = job?.phone || cr?.phone;
  const s = raw != null ? String(raw).trim() : '';
  return s || null;
}

export function resolveJobEmail(job) {
  const cr = jobClientRecord(job);
  const raw = job?.email || cr?.email;
  const s = raw != null ? String(raw).trim() : '';
  return s || null;
}

export function resolveJobClientName(job) {
  const cr = jobClientRecord(job);
  return (
    job?.client ||
    job?.client_name ||
    cr?.name ||
    null
  );
}

/** @param {string | null | undefined} phone */
export function phoneTelHref(phone) {
  if (!phone) return null;
  const normalized = String(phone).replace(/[^\d+]/g, '');
  if (!normalized) return null;
  return `tel:${normalized}`;
}

/** @param {string | null | undefined} email */
export function emailMailtoHref(email) {
  if (!email) return null;
  const trimmed = String(email).trim();
  if (!trimmed || !trimmed.includes('@')) return null;
  return `mailto:${encodeURIComponent(trimmed)}`;
}

export function formatPaymentMethod(value) {
  if (!value) return '';
  const v = String(value).replace(/_/g, ' ');
  return v.charAt(0).toUpperCase() + v.slice(1);
}
